import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import Tab from "components/Tab";
import IOSUIKit from "./code-variants/ios-uikit.mdx";
import IOSSwiftUI from "./code-variants/ios-swiftui.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`PostHog is available through `}<a parentName="p" {...{
        "href": "http://cocoapods.org"
      }}>{`CocoaPods`}</a>{` or you can add it as a Swift Package Manager based dependency.`}</p>
    <h3 {...{
      "id": "cocoapods"
    }}>{`CocoaPods`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-ruby",
        "metastring": "file=Podfile",
        "file": "Podfile"
      }}>{`pod "PostHog", "~> 3.0"
`}</code></pre>
    <h3 {...{
      "id": "swift-package-manager"
    }}>{`Swift Package Manager`}</h3>
    <p>{`Add PostHog as a dependency in your Xcode project "Package Dependencies" and select the project target for your app, as appropriate.`}</p>
    <p>{`For a Swift Package Manager based project, add PostHog as a dependency in your `}<inlineCode parentName="p">{`Package.swift`}</inlineCode>{` file's Package dependencies section:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift",
        "metastring": "file=Package.swift",
        "file": "Package.swift"
      }}>{`dependencies: [
  .package(url: "https://github.com/PostHog/posthog-ios.git", from: "3.0.0")
],
`}</code></pre>
    <p>{`and then as a dependency for the Package target utilizing PostHog:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift",
        "metastring": "file=Package.swift",
        "file": "Package.swift"
      }}>{`  .target(
    name: "myApp",
    dependencies: [.product(name: "PostHog", package: "posthog-ios")]),
`}</code></pre>
    <h3 {...{
      "id": "configuration"
    }}>{`Configuration`}</h3>
    <p>{`Configuration is done through the `}<inlineCode parentName="p">{`PostHogConfig`}</inlineCode>{` object. Here's a basic configuration example to get you started. `}</p>
    <p>{`You can find more advanced configuration options in the `}<a parentName="p" {...{
        "href": "/docs/libraries/ios/configuration"
      }}>{`configuration page`}</a>{`.`}</p>
    <Tab.Group tabs={['App Delegate/UIKit', 'SwiftUI Lifecycle']}>
     <Tab.List>
         <Tab mdxType="Tab">UIKit</Tab>
         <Tab mdxType="Tab">SwiftUI</Tab>
     </Tab.List>
     <Tab.Panels>
         <Tab.Panel>
            {IOSUIKit}
         </Tab.Panel>
         <Tab.Panel>
            {IOSSwiftUI}
         </Tab.Panel>
     </Tab.Panels>
 </Tab.Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      